import type { ValidationData } from '@/utils/sampleTypeValidation';
import type { SpreadsheetV16Settings } from '@/components/UI/SpreadSheet/SpreadsheetV16.model';
import { MultiSelectEditorV16 } from '@/components/UI/SpreadSheet/editors-v16/MultiSelectEditorV16';

import {
  buildSampleTypeValidator,
  buildSampleTypeErrorMessage,
  buildLabelValidator,
  buildLabelErrorMessage,
  buildDetailsValidator,
} from '@/components/Modals/BulkEditSampleTypes/BulkEditSampleTypes.utils.shared';

interface HotTableRefLike {
  hotInstance?: unknown;
}

interface BuildColumnsV16Params {
  availableDetailOptions: Array<string>;
  validationData: ValidationData | null;
  hotTableRef: { current: HotTableRefLike | null };
}

export const buildColumnsV16 = ({
  availableDetailOptions,
  validationData,
  hotTableRef,
}: BuildColumnsV16Params): SpreadsheetV16Settings['columns'] => {
  const validatorCtx = { validationData, sampleTypes: [], hotTableRef };

  return [
    {
      data: 0,
      value: 'Sample type',
      type: 'text',
      className: 'htMiddle',
      width: 140,
      validator: buildSampleTypeValidator(validatorCtx),
      validationErrorMessage: buildSampleTypeErrorMessage(validationData),
      linkedValidationColumns: ['0'],
    },
    {
      data: 1,
      value: 'Label',
      type: 'text',
      className: 'htMiddle',
      width: 120,
      validator: buildLabelValidator(validatorCtx),
      validationErrorMessage: buildLabelErrorMessage(validationData),
      linkedValidationColumns: ['1'],
    },
    {
      data: 2,
      value: 'Details',
      type: MultiSelectEditorV16.type,
      className: 'htMiddle',
      width: 280,
      options: availableDetailOptions,
      isMultiSelect: true,
      validator: buildDetailsValidator(availableDetailOptions),
    },
  ];
};

export const initBulkAddSampleTypesSettingsV16 = (
  columns: SpreadsheetV16Settings['columns']
): SpreadsheetV16Settings => ({
  columns,
  colHeaders: ['Sample type', 'Label', 'Details'],
  rowHeaders: true,
  manualColumnResize: true,
  contextMenu: {
    items: {
      row_above: {},
      row_below: {},
      remove_row: {},
    },
  },
  outsideClickDeselects: false,
  height: 400,
  rowHeights: 50,
  className: 'htMiddle',
  stretchH: 'all',
  minSpareRows: 1,
});
